// Connect index.html's early `beforeinstallprompt` capture to the Angular
// service before Native Federation starts loading its remote manifest.
import './app/core/services/pwa-install-prompt';
import { initializeFederationRuntimes } from './app/core/federation/federation-bootstrap';
import { logger } from './app/core/logger';

initializeFederationRuntimes()
  .catch((err) => logger.error('Federation initialization failed.', err))
  .then(() => import('./bootstrap'))
  .catch((err) => logger.error('Application bootstrap failed.', err));
